import i18n from "config/i18next";

i18n.addResources("es", "tablePickers", {
  name: "Nombre",
  identifier: "Nro. de identificación",
  email: "Email",
  vehicle: "Vehículo",
  status: "Estado",
  edit: "Editar",
  pending: "Pendiente hace",
  fixing: "En corrección",
  BICYCLE: "Bici",
  MOTORCYCLE: "Moto",
  "4_WHEELS": "Auto / Camioneta",
  day: "día",
  days: "días",
  whatsapp: "WhatsApp",
  incomplete: "Incompleto",
  contactText: "¡Hola! {{name}}, ¿cómo estás?, nos comunicamos desde pickers",
});

i18n.addResources("es_AR", "tablePickers", {
  identifier: "DNI",
});

i18n.addResources("es_MX", "tablePickers", {
  identifier: "CURP",
});

i18n.addResources("es_CL", "tablePickers", {
  identifier: "RUN",
});
